type LocLabelSource = {
    facilityLevelOfCareCode?: string | null;
    facilityLevelOfCareName?: string | null;
    facilityLevelOfCareOverrideName?: string | null;
    cfgLevelOfCareId?: string | number | null;
};

type MasterLocLabel = {
    levelOfCareId?: string | number | null;
    levelOfCareCode?: string | null;
    levelOfCareName?: string | null;
};

const nonBlank = (value?: string | null): string => value?.trim() ?? '';

/**
 * Covered LOC title in VOB.
 * Name: facility override name when set, otherwise the master LOC name.
 * Code: facility override code when set, otherwise the master LOC code.
 */
export const getCoveredLocTitle = (
    level: LocLabelSource,
    masterLevels?: MasterLocLabel[] | null
): string => {
    const master = masterLevels?.find(
        (loc) =>
            loc.levelOfCareId != null &&
            level.cfgLevelOfCareId != null &&
            Number(loc.levelOfCareId) === Number(level.cfgLevelOfCareId)
    );

    const name =
        nonBlank(level.facilityLevelOfCareOverrideName) ||
        nonBlank(level.facilityLevelOfCareName) ||
        nonBlank(master?.levelOfCareName);
    const code =
        nonBlank(level.facilityLevelOfCareCode) ||
        nonBlank(master?.levelOfCareCode);

    return [code, name].filter(Boolean).join(' ');
};
